import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1e2cf79c = () => interopDefault(import('../../../pages/404-error/index.vue' /* webpackChunkName: "pages/404-error/index" */))
const _2334d2a0 = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _315d2d5c = () => interopDefault(import('../../../pages/buy-sell-your-home/index.vue' /* webpackChunkName: "pages/buy-sell-your-home/index" */))
const _16b759f1 = () => interopDefault(import('../../../pages/buy-your-home/index.vue' /* webpackChunkName: "pages/buy-your-home/index" */))
const _85afe696 = () => interopDefault(import('../../../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _1a3dce3e = () => interopDefault(import('../../../pages/commissions-calculator/index.vue' /* webpackChunkName: "pages/commissions-calculator/index" */))
const _88fdfd50 = () => interopDefault(import('../../../pages/comparables/index.vue' /* webpackChunkName: "pages/comparables/index" */))
const _621d57df = () => interopDefault(import('../../../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _25801556 = () => interopDefault(import('../../../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _8c184f3e = () => interopDefault(import('../../../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _36b9d9ed = () => interopDefault(import('../../../pages/list-home/index.vue' /* webpackChunkName: "pages/list-home/index" */))
const _1fb6e7ba = () => interopDefault(import('../../../pages/listing-management/index.vue' /* webpackChunkName: "pages/listing-management/index" */))
const _11fe34e8 = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _00c3669a = () => interopDefault(import('../../../pages/market-data/index.vue' /* webpackChunkName: "pages/market-data/index" */))
const _6d1f4d7a = () => interopDefault(import('../../../pages/messages/index.vue' /* webpackChunkName: "pages/messages/index" */))
const _7591df17 = () => interopDefault(import('../../../pages/my-abode-overview/index.vue' /* webpackChunkName: "pages/my-abode-overview/index" */))
const _16dee9a2 = () => interopDefault(import('../../../pages/my-listings/index.vue' /* webpackChunkName: "pages/my-listings/index" */))
const _11cbb71e = () => interopDefault(import('../../../pages/offer-management-buyer/index.vue' /* webpackChunkName: "pages/offer-management-buyer/index" */))
const _69bc90d7 = () => interopDefault(import('../../../pages/offer-management-seller/index.vue' /* webpackChunkName: "pages/offer-management-seller/index" */))
const _38d52ece = () => interopDefault(import('../../../pages/offers/index.vue' /* webpackChunkName: "pages/offers/index" */))
const _0a5d3547 = () => interopDefault(import('../../../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _f1cdc8be = () => interopDefault(import('../../../pages/pro-edit/index.vue' /* webpackChunkName: "pages/pro-edit/index" */))
const _7871f12a = () => interopDefault(import('../../../pages/pro-marketplace/index.vue' /* webpackChunkName: "pages/pro-marketplace/index" */))
const _e34a5282 = () => interopDefault(import('../../../pages/pro-search/index.vue' /* webpackChunkName: "pages/pro-search/index" */))
const _1217b604 = () => interopDefault(import('../../../pages/request-sticker/index.vue' /* webpackChunkName: "pages/request-sticker/index" */))
const _3f57419f = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _b5a2a416 = () => interopDefault(import('../../../pages/sell-your-home/index.vue' /* webpackChunkName: "pages/sell-your-home/index" */))
const _698ec10f = () => interopDefault(import('../../../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _73b21c02 = () => interopDefault(import('../../../pages/sold-data/index.vue' /* webpackChunkName: "pages/sold-data/index" */))
const _53dc217c = () => interopDefault(import('../../../pages/terms-of-service/index.vue' /* webpackChunkName: "pages/terms-of-service/index" */))
const _12dc58c7 = () => interopDefault(import('../../../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _7a2f98bf = () => interopDefault(import('../../../pages/whoweare/index.vue' /* webpackChunkName: "pages/whoweare/index" */))
const _4a4f7faa = () => interopDefault(import('../../../pages/why-bode/index.vue' /* webpackChunkName: "pages/why-bode/index" */))
const _64318f7a = () => interopDefault(import('../../../pages/admin/conversation/index.vue' /* webpackChunkName: "pages/admin/conversation/index" */))
const _59fefee4 = () => interopDefault(import('../../../pages/admin/offers/index.vue' /* webpackChunkName: "pages/admin/offers/index" */))
const _cef7cef6 = () => interopDefault(import('../../../pages/admin/showings/index.vue' /* webpackChunkName: "pages/admin/showings/index" */))
const _6e626d98 = () => interopDefault(import('../../../pages/listings/review.vue' /* webpackChunkName: "pages/listings/review" */))
const _68c1030e = () => interopDefault(import('../../../pages/login/idp/index.vue' /* webpackChunkName: "pages/login/idp/index" */))
const _7c02acb0 = () => interopDefault(import('../../../pages/login/reset/index.vue' /* webpackChunkName: "pages/login/reset/index" */))
const _3ebaf67e = () => interopDefault(import('../../../pages/offers/constants/index.js' /* webpackChunkName: "pages/offers/constants/index" */))
const _c1375844 = () => interopDefault(import('../../../pages/offers/enums/index.js' /* webpackChunkName: "pages/offers/enums/index" */))
const _5a1df88a = () => interopDefault(import('../../../pages/pro-edit/profile/index.vue' /* webpackChunkName: "pages/pro-edit/profile/index" */))
const _36b661c7 = () => interopDefault(import('../../../pages/pro-edit/service/index.vue' /* webpackChunkName: "pages/pro-edit/service/index" */))
const _e6a816f2 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/index" */))
const _c6a90238 = () => interopDefault(import('../../../pages/pro-marketplace/pro-login/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-login/index" */))
const _091fb4e7 = () => interopDefault(import('../../../pages/pro-marketplace/pro-portal/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-portal/index" */))
const _4e8ab6dc = () => interopDefault(import('../../../pages/pro-marketplace/service-request/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/index" */))
const _4acb2537 = () => interopDefault(import('../../../pages/pro-marketplace/service-requests/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-requests/index" */))
const _496753a6 = () => interopDefault(import('../../../pages/search/saved-search-list/index.vue' /* webpackChunkName: "pages/search/saved-search-list/index" */))
const _0cd4abdc = () => interopDefault(import('../../../pages/signup/additional-information/index.vue' /* webpackChunkName: "pages/signup/additional-information/index" */))
const _0110f100 = () => interopDefault(import('../../../pages/signup/confirm/index.vue' /* webpackChunkName: "pages/signup/confirm/index" */))
const _0d2b01f8 = () => interopDefault(import('../../../pages/admin/listings/import/index.vue' /* webpackChunkName: "pages/admin/listings/import/index" */))
const _4e402728 = () => interopDefault(import('../../../pages/admin/listings/update/index.vue' /* webpackChunkName: "pages/admin/listings/update/index" */))
const _225a0d79 = () => interopDefault(import('../../../pages/ds/callback/listing/index.vue' /* webpackChunkName: "pages/ds/callback/listing/index" */))
const _4930245e = () => interopDefault(import('../../../pages/ds/callback/offer/index.vue' /* webpackChunkName: "pages/ds/callback/offer/index" */))
const _77d48183 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index" */))
const _eaf148cc = () => interopDefault(import('../../../pages/pro-marketplace/service-request/photography-measurements/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/photography-measurements/index" */))
const _e409de3e = () => interopDefault(import('../../../pages/admin/listings/update/form/index.vue' /* webpackChunkName: "pages/admin/listings/update/form/index" */))
const _8dd990b2 = () => interopDefault(import('../../../pages/admin/listings/update/table/index.vue' /* webpackChunkName: "pages/admin/listings/update/table/index" */))
const _b433ff08 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index" */))
const _7c6e480e = () => interopDefault(import('../../../pages/admin/listings/update/form/constants/index.js' /* webpackChunkName: "pages/admin/listings/update/form/constants/index" */))
const _1a03d695 = () => interopDefault(import('../../../pages/admin/listings/update/form/controls/index.js' /* webpackChunkName: "pages/admin/listings/update/form/controls/index" */))
const _71b78bc0 = () => interopDefault(import('../../../pages/admin/listings/update/form/listing-item/index.vue' /* webpackChunkName: "pages/admin/listings/update/form/listing-item/index" */))
const _607558eb = () => interopDefault(import('../../../pages/admin/listings/update/services/AdminUpdateListingTableMapService.js' /* webpackChunkName: "pages/admin/listings/update/services/AdminUpdateListingTableMapService" */))
const _63993601 = () => interopDefault(import('../../../pages/admin/listings/update/table/checkbox-cell.vue' /* webpackChunkName: "pages/admin/listings/update/table/checkbox-cell" */))
const _23ee6008 = () => interopDefault(import('../../../pages/admin/listings/update/table/constants/index.js' /* webpackChunkName: "pages/admin/listings/update/table/constants/index" */))
const _a2122ab6 = () => interopDefault(import('../../../pages/admin/listings/update/table/enums/index.js' /* webpackChunkName: "pages/admin/listings/update/table/enums/index" */))
const _956bcdf0 = () => interopDefault(import('../../../pages/admin/listings/update/table/header.vue' /* webpackChunkName: "pages/admin/listings/update/table/header" */))
const _9ea8bc3e = () => interopDefault(import('../../../pages/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps.js' /* webpackChunkName: "pages/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps" */))
const _1888cda2 = () => interopDefault(import('../../../pages/pro-marketplace/profile/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/profile/_id/index" */))
const _1806a0ed = () => interopDefault(import('../../../pages/pro-marketplace/view-request/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/view-request/_id/index" */))
const _0d57acaa = () => interopDefault(import('../../../pages/buyer-checklist/_page/index.vue' /* webpackChunkName: "pages/buyer-checklist/_page/index" */))
const _ce506a42 = () => interopDefault(import('../../../pages/how-it-works/_id/index.vue' /* webpackChunkName: "pages/how-it-works/_id/index" */))
const _65e5178e = () => interopDefault(import('../../../pages/listing-editing/_id/index.vue' /* webpackChunkName: "pages/listing-editing/_id/index" */))
const _eff512de = () => interopDefault(import('../../../pages/listings/_id/index.vue' /* webpackChunkName: "pages/listings/_id/index" */))
const _c9401dd2 = () => interopDefault(import('../../../pages/pro/_id/index.vue' /* webpackChunkName: "pages/pro/_id/index" */))
const _0b6686a4 = () => interopDefault(import('../../../pages/seller-checklist/_page/index.vue' /* webpackChunkName: "pages/seller-checklist/_page/index" */))
const _7df99b5e = () => interopDefault(import('../../../pages/settings/_section/index.vue' /* webpackChunkName: "pages/settings/_section/index" */))
const _6c6e7350 = () => interopDefault(import('../../../pages/sold-property/_id/index.vue' /* webpackChunkName: "pages/sold-property/_id/index" */))
const _7b6a88ed = () => interopDefault(import('../../../pages/user/_id/index.vue' /* webpackChunkName: "pages/user/_id/index" */))
const _0332081d = () => interopDefault(import('../../../pages/listings/_id/audit/index.vue' /* webpackChunkName: "pages/listings/_id/audit/index" */))
const _31a53816 = () => interopDefault(import('../../../pages/listings/_id/dashboard/index.vue' /* webpackChunkName: "pages/listings/_id/dashboard/index" */))
const _4bd461e2 = () => interopDefault(import('../../../pages/listings/_id/submit-success/index.vue' /* webpackChunkName: "pages/listings/_id/submit-success/index" */))
const _c85a2398 = () => interopDefault(import('../../../pages/offers/_id/agreement/index.vue' /* webpackChunkName: "pages/offers/_id/agreement/index" */))
const _020b0a3b = () => interopDefault(import('../../../pages/settings/_section/enums/index.js' /* webpackChunkName: "pages/settings/_section/enums/index" */))
const _6c4e9c0e = () => interopDefault(import('../../../pages/listings/_id/dashboard/enums.js' /* webpackChunkName: "pages/listings/_id/dashboard/enums" */))
const _41a11c58 = () => interopDefault(import('../../../pages/listings/_id/viewings/_type/index.vue' /* webpackChunkName: "pages/listings/_id/viewings/_type/index" */))
const _ac1dbf0e = () => interopDefault(import('../../../pages/users/_id/_section/index.vue' /* webpackChunkName: "pages/users/_id/_section/index" */))
const _251c09e4 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404-error",
    component: _1e2cf79c,
    name: "404-error"
  }, {
    path: "/app",
    component: _2334d2a0,
    name: "app"
  }, {
    path: "/buy-sell-your-home",
    component: _315d2d5c,
    name: "buy-sell-your-home"
  }, {
    path: "/buy-your-home",
    component: _16b759f1,
    name: "buy-your-home"
  }, {
    path: "/calendar",
    component: _85afe696,
    name: "calendar"
  }, {
    path: "/commissions-calculator",
    component: _1a3dce3e,
    name: "commissions-calculator"
  }, {
    path: "/comparables",
    component: _88fdfd50,
    name: "comparables"
  }, {
    path: "/contact",
    component: _621d57df,
    name: "contact"
  }, {
    path: "/faq",
    component: _25801556,
    name: "faq"
  }, {
    path: "/favourites",
    component: _8c184f3e,
    name: "favourites"
  }, {
    path: "/list-home",
    component: _36b9d9ed,
    name: "list-home"
  }, {
    path: "/listing-management",
    component: _1fb6e7ba,
    name: "listing-management"
  }, {
    path: "/login",
    component: _11fe34e8,
    name: "login"
  }, {
    path: "/market-data",
    component: _00c3669a,
    name: "market-data"
  }, {
    path: "/messages",
    component: _6d1f4d7a,
    name: "messages"
  }, {
    path: "/my-abode-overview",
    component: _7591df17,
    name: "my-abode-overview"
  }, {
    path: "/my-listings",
    component: _16dee9a2,
    name: "my-listings"
  }, {
    path: "/offer-management-buyer",
    component: _11cbb71e,
    name: "offer-management-buyer"
  }, {
    path: "/offer-management-seller",
    component: _69bc90d7,
    name: "offer-management-seller"
  }, {
    path: "/offers",
    component: _38d52ece,
    name: "offers"
  }, {
    path: "/privacy",
    component: _0a5d3547,
    name: "privacy"
  }, {
    path: "/pro-edit",
    component: _f1cdc8be,
    name: "pro-edit"
  }, {
    path: "/pro-marketplace",
    component: _7871f12a,
    name: "pro-marketplace"
  }, {
    path: "/pro-search",
    component: _e34a5282,
    name: "pro-search"
  }, {
    path: "/request-sticker",
    component: _1217b604,
    name: "request-sticker"
  }, {
    path: "/search",
    component: _3f57419f,
    name: "search"
  }, {
    path: "/sell-your-home",
    component: _b5a2a416,
    name: "sell-your-home"
  }, {
    path: "/signup",
    component: _698ec10f,
    name: "signup"
  }, {
    path: "/sold-data",
    component: _73b21c02,
    name: "sold-data"
  }, {
    path: "/terms-of-service",
    component: _53dc217c,
    name: "terms-of-service"
  }, {
    path: "/users",
    component: _12dc58c7,
    name: "users"
  }, {
    path: "/whoweare",
    component: _7a2f98bf,
    name: "whoweare"
  }, {
    path: "/why-bode",
    component: _4a4f7faa,
    name: "why-bode"
  }, {
    path: "/admin/conversation",
    component: _64318f7a,
    name: "admin-conversation"
  }, {
    path: "/admin/offers",
    component: _59fefee4,
    name: "admin-offers"
  }, {
    path: "/admin/showings",
    component: _cef7cef6,
    name: "admin-showings"
  }, {
    path: "/listings/review",
    component: _6e626d98,
    name: "listings-review"
  }, {
    path: "/login/idp",
    component: _68c1030e,
    name: "login-idp"
  }, {
    path: "/login/reset",
    component: _7c02acb0,
    name: "login-reset"
  }, {
    path: "/offers/constants",
    component: _3ebaf67e,
    name: "offers-constants"
  }, {
    path: "/offers/enums",
    component: _c1375844,
    name: "offers-enums"
  }, {
    path: "/pro-edit/profile",
    component: _5a1df88a,
    name: "pro-edit-profile"
  }, {
    path: "/pro-edit/service",
    component: _36b661c7,
    name: "pro-edit-service"
  }, {
    path: "/pro-marketplace/marketplace-for-pros",
    component: _e6a816f2,
    name: "pro-marketplace-marketplace-for-pros"
  }, {
    path: "/pro-marketplace/pro-login",
    component: _c6a90238,
    name: "pro-marketplace-pro-login"
  }, {
    path: "/pro-marketplace/pro-portal",
    component: _091fb4e7,
    name: "pro-marketplace-pro-portal"
  }, {
    path: "/pro-marketplace/service-request",
    component: _4e8ab6dc,
    name: "pro-marketplace-service-request"
  }, {
    path: "/pro-marketplace/service-requests",
    component: _4acb2537,
    name: "pro-marketplace-service-requests"
  }, {
    path: "/search/saved-search-list",
    component: _496753a6,
    name: "search-saved-search-list"
  }, {
    path: "/signup/additional-information",
    component: _0cd4abdc,
    name: "signup-additional-information"
  }, {
    path: "/signup/confirm",
    component: _0110f100,
    name: "signup-confirm"
  }, {
    path: "/admin/listings/import",
    component: _0d2b01f8,
    name: "admin-listings-import"
  }, {
    path: "/admin/listings/update",
    component: _4e402728,
    name: "admin-listings-update"
  }, {
    path: "/ds/callback/listing",
    component: _225a0d79,
    name: "ds-callback-listing"
  }, {
    path: "/ds/callback/offer",
    component: _4930245e,
    name: "ds-callback-offer"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up",
    component: _77d48183,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up"
  }, {
    path: "/pro-marketplace/service-request/photography-measurements",
    component: _eaf148cc,
    name: "pro-marketplace-service-request-photography-measurements"
  }, {
    path: "/admin/listings/update/form",
    component: _e409de3e,
    name: "admin-listings-update-form"
  }, {
    path: "/admin/listings/update/table",
    component: _8dd990b2,
    name: "admin-listings-update-table"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up/successful",
    component: _b433ff08,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up-successful"
  }, {
    path: "/admin/listings/update/form/constants",
    component: _7c6e480e,
    name: "admin-listings-update-form-constants"
  }, {
    path: "/admin/listings/update/form/controls",
    component: _1a03d695,
    name: "admin-listings-update-form-controls"
  }, {
    path: "/admin/listings/update/form/listing-item",
    component: _71b78bc0,
    name: "admin-listings-update-form-listing-item"
  }, {
    path: "/admin/listings/update/services/AdminUpdateListingTableMapService",
    component: _607558eb,
    name: "admin-listings-update-services-AdminUpdateListingTableMapService"
  }, {
    path: "/admin/listings/update/table/checkbox-cell",
    component: _63993601,
    name: "admin-listings-update-table-checkbox-cell"
  }, {
    path: "/admin/listings/update/table/constants",
    component: _23ee6008,
    name: "admin-listings-update-table-constants"
  }, {
    path: "/admin/listings/update/table/enums",
    component: _a2122ab6,
    name: "admin-listings-update-table-enums"
  }, {
    path: "/admin/listings/update/table/header",
    component: _956bcdf0,
    name: "admin-listings-update-table-header"
  }, {
    path: "/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps",
    component: _9ea8bc3e,
    name: "admin-listings-update-table-mixins-AdminListingsUpdateTableRowsProps"
  }, {
    path: "/pro-marketplace/profile/:id",
    component: _1888cda2,
    name: "pro-marketplace-profile-id"
  }, {
    path: "/pro-marketplace/view-request/:id",
    component: _1806a0ed,
    name: "pro-marketplace-view-request-id"
  }, {
    path: "/buyer-checklist/:page",
    component: _0d57acaa,
    name: "buyer-checklist-page"
  }, {
    path: "/how-it-works/:id",
    component: _ce506a42,
    name: "how-it-works-id"
  }, {
    path: "/listing-editing/:id",
    component: _65e5178e,
    name: "listing-editing-id"
  }, {
    path: "/listings/:id",
    component: _eff512de,
    name: "listings-id"
  }, {
    path: "/pro/:id",
    component: _c9401dd2,
    name: "pro-id"
  }, {
    path: "/seller-checklist/:page",
    component: _0b6686a4,
    name: "seller-checklist-page"
  }, {
    path: "/settings/:section",
    component: _7df99b5e,
    name: "settings-section"
  }, {
    path: "/sold-property/:id",
    component: _6c6e7350,
    name: "sold-property-id"
  }, {
    path: "/user/:id",
    component: _7b6a88ed,
    name: "user-id"
  }, {
    path: "/listings/:id?/audit",
    component: _0332081d,
    name: "listings-id-audit"
  }, {
    path: "/listings/:id?/dashboard",
    component: _31a53816,
    name: "listings-id-dashboard"
  }, {
    path: "/listings/:id?/submit-success",
    component: _4bd461e2,
    name: "listings-id-submit-success"
  }, {
    path: "/offers/:id/agreement",
    component: _c85a2398,
    name: "offers-id-agreement"
  }, {
    path: "/settings/:section?/enums",
    component: _020b0a3b,
    name: "settings-section-enums"
  }, {
    path: "/listings/:id?/dashboard/enums",
    component: _6c4e9c0e,
    name: "listings-id-dashboard-enums"
  }, {
    path: "/listings/:id?/viewings/:type",
    component: _41a11c58,
    name: "listings-id-viewings-type"
  }, {
    path: "/users/:id/:section",
    component: _ac1dbf0e,
    name: "users-id-section"
  }, {
    path: "/",
    component: _251c09e4,
    name: "index"
  }, {
    path: "/buyer-checklist",
    redirect: "/buyer-checklist/getting-ready",
    name: "/buyer-checklist"
  }, {
    path: "/how-it-works",
    redirect: "/how-it-works/seller",
    name: "/how-it-works"
  }, {
    path: "/howitworks",
    redirect: "/how-it-works/seller",
    name: "/howitworks"
  }, {
    path: "/listings",
    redirect: "/search",
    name: "/listings"
  }, {
    path: "/listings/:city/:community/:propertyType/:price/:id",
    redirect: "/listings/:id",
    name: "/listings/:city/:community/:propertyType/:price/:id"
  }, {
    path: "/logout",
    redirect: "/",
    name: "/logout"
  }, {
    path: "/error404",
    redirect: "/404-error",
    name: "/error404"
  }, {
    path: "/pro-:id-:companyname",
    redirect: "/pro/:id",
    name: "/pro-:id-:companyname"
  }, {
    path: "/profiles/:id",
    redirect: "/users/:id",
    name: "/profiles/:id"
  }, {
    path: "/seller-checklist",
    redirect: "/seller-checklist/getting-ready",
    name: "/seller-checklist"
  }, {
    path: "/start-listing",
    redirect: "/sell-your-home",
    name: "/start-listing"
  }, {
    path: "/terms",
    redirect: "/terms-of-service",
    name: "/terms"
  }, {
    path: "/whybode",
    redirect: "/why-bode",
    name: "/whybode"
  }, {
    path: "/who-we-are",
    redirect: "/whoweare",
    name: "/who-we-are"
  }, {
    path: "/offers/seller",
    redirect: "/offer-management-seller",
    name: "/offers/seller"
  }, {
    path: "/offers/buyer",
    redirect: "/offer-management-buyer",
    name: "/offers/buyer"
  }, {
    path: "/documents",
    redirect: "/offer-management-seller",
    name: "/documents"
  }, {
    path: "/list-your-home",
    redirect: "/list-home",
    name: "/list-your-home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
